import { render, staticRenderFns } from "./IconChevronUp.vue?vue&type=template&id=3b85e974"
import script from "./IconChevronUp.vue?vue&type=script&lang=js"
export * from "./IconChevronUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports